export const fixPropWarnings = (...props: string[]) => ({
  shouldForwardProp: excludeProps(...props),
});

export const excludeProps = (...props: string[]) => (
  (prop: string) => ![...styledSystemProps, ...props].includes(prop)
);

const styledSystemProps = [
  'x',
  'y',
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'textAlign',
  'minWidth',
  'maxWidth',
  'minHeight',
  'maxHeight',
  'flexDirection',
  'flexWrap',
  'alignItems',
  'alignSelf',
  'justifyContent',
  'justifySelf',
  'bg',
  'backgroundColor',
];
